// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1yJXU","notes":"Notes_notes__2uLvv","note":"Notes_note__3YkjZ","markdown":"Notes_markdown__2bhoq"};